import { ReactElement } from "react";
import { Box } from "@mui/material";


interface IProps {
  title: string;
  value: number | string | boolean | ReactElement | null | undefined;
  color: string | ((value: any) => string);
  fontSize?: string;
  background?: string;
}

const ItemValue = ({ title, value, color, fontSize, background }: IProps): ReactElement => {

  const selector = () => {
    if (typeof value === "number") {
      return <strong style={{ color: typeof color === "string" ? color : color(value), fontSize }}>{value.toFixed(2)}</strong>;
    }

    if (typeof value === "string") {
      return <strong style={{ color: typeof color === "string" ? color : color(value), fontSize }}>{value}</strong>;
    }

    return value ?? <strong style={{ color: typeof color === "string" ? color : color(value), fontSize }}>---</strong>;
  };

  return (
    <Box className="display-grid border-rounded-2 scroll-hidden" style={{ gridTemplateColumns: "1fr", gridTemplateRows: "auto auto", justifyItems: "stretch" }}>
      <div className="display-grid justify-content-center scroll-hidden" style={{ background: "rgba(127, 127, 127, .5)" }} >
        <strong>{title}</strong>
      </div>
      <div className="display-grid justify-content-center" style={{ background }} >
        {selector()}
      </div>
    </Box>
  );
};

export default ItemValue;
